import React from "react";
import {Helmet} from "react-helmet";

export const A29Meta = () => (
    <Helmet>
        <title>Guillermina Etchebarne | Vieunite </title>
        <meta name="description"
              content="Guillermina Etchebarne focuses her lens on the untamed wilderness and the lives of the farmhands who work through the harsh Patagonian winters, telling stories of resilience and tradition against a backdrop of breathtaking scenery "/>
        <meta name="keywords"
              content="digital canvas, digital frame, digital art frame, digital art canvas, Guillermina Etchebarne, digital art, photography, rugged landscapes, untamed wilderness, Patagonian winters, people, story telling, Vieunite artist "/>
        <meta name="twitter:card" value="summary"/>
        <meta name="twitter:site" value="@VieuniteHQ"/>
        <meta name="twitter:title" value="Vieunite Artist | Rachel Sheree"/>
        <meta name="twitter:description"
              content=" With a deep-rooted love for storytelling and self-expression, her work spans diverse mediums, including painting, illustration and surface design."/>
        <meta name="twitter:url" value="https://vieunite.com/images/vieunite_sc_rachel_sheree.jpg"/>
        <meta name="twitter:image" value="https://vieunite.com/images/vieunite_sc_rachel_sheree.jpg"/>

        <meta property="og:url" content="https://vieunite.com/images/vieunite_sc_rachel_sheree.jpg"/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content="Vieunite Artist | Rachel Sheree"/>
        <meta property="og:description"
              content=" With a deep-rooted love for storytelling and self-expression, her work spans diverse mediums, including painting, illustration and surface design. "/>
        <meta property="og:image" content="https://vieunite.com/images/vieunite_sc_rachel_sheree.jpg"/>

    </Helmet>);